export class Controller {

    /** @ngInject */
    constructor(
        AuthenticationAccessPolicyResource,
        Alert,
        $state
        ) {
        this.Alert= Alert;
        this.$state= $state;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
    }

    $onInit() {
        this.newAuthAccessSettings = angular.copy(this.authenticationAccessPolicyList);        
        if (this.application.accessPolicyId) {
            this.selectedPolicyId = this.application.accessPolicyId;
        } else {
            this.selectedPolicyId = '-1';
        }
    }

    is(...types) {
        return types.includes(this.application.applicationType.slug);
    }

    saveDisabled() {
        return this.isSaving || this.notModified();
    }

    notModified() {
        return this.application.accessPolicyId === this.selectedPolicyId || (this.application.accessPolicyId == null && this.selectedPolicyId == -1);
    }

    saveAuthPolicy(){
        this.isSaving = true;
        this.AuthenticationAccessPolicyResource.applyPolicy(this.companyId, this.selectedPolicyId, this.application.id)
            .then(()=>{
                this.Alert(
                    'success',
                    'company.policies.settings_updated'
                )
            })
            .then(() => this.$state.reload('company.manage-application'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/access-control-policy/access-control-policy.controller.js